import React from 'react'

const EscapeDrag = (props) => {
  return (
    <span className={'escapeDragScroll'} style={{ cursor: 'text' }}>
      {props?.children}
    </span>
  )
}

export default EscapeDrag
